import { render, staticRenderFns } from "./heartBg.vue?vue&type=template&id=2e33acfc&scoped=true&"
import script from "./heartBg.vue?vue&type=script&lang=js&"
export * from "./heartBg.vue?vue&type=script&lang=js&"
import style0 from "./heartBg.vue?vue&type=style&index=0&id=2e33acfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33acfc",
  null
  
)

export default component.exports